import { MEElement } from '../../base/me-element.js';
import sheet from './stack.styles.js';

export class MEStack extends MEElement {
  static observedAttributes = ['direction', 'spacing', 'align', 'justify', 'flex-wrap'];

  constructor() {
    super();
    this.shadow.adoptedStyleSheets = [sheet];
  }

  protected render(): void {
    const spacing = this.getAttribute('spacing');
    if (spacing !== null) {
      const gap = isNaN(Number(spacing))
        ? spacing
        : `calc(var(--me-spacing, 8px) * ${spacing})`;
      this.style.setProperty('gap', gap);
    } else {
      this.style.removeProperty('gap');
    }
    this.shadow.innerHTML = `<slot></slot>`;
  }
}
